import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';
import { TitleUI } from '../../../components/UI/LabelTitleUI';

const Configuration = () => {
    const menu = () => {
        let menuItems = [];

        if (checkPermission(PERMISSIONS.Config.Global.Plant)) {
            menuItems = [...menuItems, { route: 'config/plant', icon: 'mdi mdi-domain', text: translate('menu:plant') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Resource)) {
            menuItems = [...menuItems, { route: 'config/resource', icon: 'mdi mdi-select-group', text: translate('menu:resource') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Printer)) {
            menuItems = [...menuItems, { route: 'config/print', icon: 'mdi mdi-printer', text: translate('menu:printer') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Access)) {
            menuItems = [...menuItems, { route: 'config/params', icon: 'mdi mdi-cogs', text: translate('menu:parameterization') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Access) === true) {
            menuItems = [...menuItems, { route: 'config/user', icon: 'mdi mdi-account', text: translate('menu:user') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Justification) === true) {
            menuItems = [...menuItems, { route: 'config/justification', icon: 'mdi mdi-folder-text-outline', text: translate('menu:justification') }];
        }

        if (checkPermission(PERMISSIONS.Config.Global.Justification) === true) {
            menuItems = [...menuItems, { route: 'config/movementType', icon: 'mdi mdi-repeat', text: translate('menu.movementType', 'configuration') }];
        }

        if (checkPermission(PERMISSIONS.Config.Equipment.Access) === true) {
            menuItems = [...menuItems, { route: 'config/equipment', icon: 'build', text: translate('menu:equipment') }];
        }

        menuItems = [...menuItems, {
            route: 'config/alternativeMdrPartnumber/home',
            icon: 'filter_frames',
            text: translate('label-alternativeMdrPartnumber', 'physical-confirmation')
        }];

        menuItems = [...menuItems, {
            route: 'config/qmePartNumber/home',
            icon: 'filter_frames',
            text: translate('label-qmePartNumber', 'physical-confirmation')
        }];

        menuItems = [...menuItems, { route: 'config/areaPdu', icon: 'mdi mdi-monitor', text: translate('pointArea.point-area', 'configuration') }];
        menuItems = [...menuItems, { route: 'config/token', icon: 'mdi mdi-shield-key-outline', text: translate('menu:token') }];

        if (checkPermission(PERMISSIONS.Config.Global.Access)) {
            menuItems = [...menuItems, { route: 'config/monitor', icon: 'mdi mdi-monitor', text: translate('menu:monitor') }];
        }

        menuItems = [...menuItems, { route: 'config/serviceMonitor', icon: 'mdi mdi-monitor', text: translate('logistic-service', 'general') }];
        menuItems = [...menuItems, { route: 'config/alert/emailInsert', icon: 'build', text: "Alerta E-mail" }];

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

export default withRouter(withTranslation()(Configuration));
